import { getFullUrl } from 'hubspot-url-utils';
export const isHubSpotDotComAuthedUserRedirect = () => {
  // Has to work for different TLDs, e.g. www.hubspot.jp
  const WWW_REFERRER_SUBSTRING = 'www.hubspot.';
  const BR_REFERRER_SUBSTRING = 'br.hubspot.';
  // If you have multiple portals, you go from public pricing -> portal picker page -> in-app page. This is not perfect detection
  // as it will pick up ANY time you short link to pricing, regardless
  // of origin, but this is likely CloseEnough.
  const PORTAL_PICKER_REFERRER_SUBSTRING = `${getFullUrl('app')}/portal-recommend/l?slug=pricing`;
  const QA_TEST_REFERRER_SUBSTRING = '/public-pricing';
  const {
    referrer
  } = document;
  return referrer.includes(WWW_REFERRER_SUBSTRING) || referrer.includes(BR_REFERRER_SUBSTRING) || referrer.includes(QA_TEST_REFERRER_SUBSTRING) || referrer.includes(PORTAL_PICKER_REFERRER_SUBSTRING);
};